import React from 'react';

const TipPool = ({ dailyShifts }) => {
  return (
    <div>
      <div>
        <span>
          <label>Lunch Tip Pool:&nbsp;&nbsp; </label>
          <span>
            <b>{dailyShifts.lunchTipPool}</b>
          </span>
        </span>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        {/* <br/> */}
        {/* <span><label>Lunch Host Tips:&nbsp;&nbsp;</label><span>{dailyShifts.totalLunchHostTips}</span></span><span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span><label>Total Lunch TipOut:&nbsp;&nbsp;</label><span>{dailyShifts.totalLunchTipOut}</span></span><span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span><label>Total Lunch TipOut (including CC tip fee):&nbsp;&nbsp;</label><span><b>{Number((dailyShifts.totalLunchTipOut/0.975).toFixed(2))}</b></span></span><span>&nbsp;&nbsp;&nbsp;&nbsp;</span> */}
        {/* </div>
        <div> */}
        <span>
          <label>Dinner Tip Pool:&nbsp;&nbsp;</label>
          <span>
            <b>{dailyShifts.dinnerTipPool}</b>
          </span>
        </span>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <br />
        <span>
          <label>Bar Tips:&nbsp;&nbsp;</label>
          <span>{dailyShifts.totalBarTips}</span>
        </span>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span>
          <label>Daily Host Tips:&nbsp;&nbsp;</label>
          <span>
            {Number(
              (
                dailyShifts.totalHostTips + dailyShifts.totalLunchHostTips
              ).toFixed(2),
            )}
          </span>
        </span>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span>
          <label>Expo Tips:&nbsp;&nbsp;</label>
          <span>{dailyShifts.totalExpoTips}</span>
        </span>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span>
          <label>Busser Tips:&nbsp;&nbsp;</label>
          <span>{dailyShifts.totalBusserTips}</span>
        </span>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <br />
        <span>
          <label>Daily Tip Pool:&nbsp;&nbsp;</label>
          <span>
            <b>
              {Number(
                (dailyShifts.dinnerTipPool + dailyShifts.lunchTipPool).toFixed(
                  2,
                ),
              )}
            </b>
          </span>
        </span>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <br />
        {/* <span><label>Total Dinner TipOut:&nbsp;&nbsp;</label><span>{dailyShifts.totalDinnerTipOut}</span></span><span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span><label>Total Dinner TipOut (including CC tip fee):&nbsp;&nbsp;</label><span><b>{Number((dailyShifts.totalDinnerTipOut/0.975).toFixed(2))}</b></span></span><span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <br/> */}
        <span>
          <label>Total Daily TipOut (After withholding):&nbsp;&nbsp;</label>
          <span>
            <b>
              {Number(
                (
                  dailyShifts.totalDinnerTipOut + dailyShifts.totalLunchTipOut
                ).toFixed(2),
              )}
            </b>
          </span>
        </span>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        {/* <span>
          <label>Total Daily TipOut (including CC tip fee):&nbsp;&nbsp;</label>
          <span>
            <b>
              {Number(
                (
                  (dailyShifts.totalDinnerTipOut +
                    dailyShifts.totalLunchTipOut) /
                  0.975
                ).toFixed(2),
              )}
            </b>
          </span>
        </span>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;</span> */}
      </div>
    </div>
  );
};

export default TipPool;
